import React from 'react'

const ContainerIcon = ({ size = 16, className }) => {
    return (
        <span className={className}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                fill="none"
                viewBox="0 0 16 16"
            >
                <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 10V7.22c0-.307-.173-.727-.393-.947L10.193 4.86A.67.67 0 0 1 10 4.393v-1.06H6v1.06a.67.67 0 0 1-.193.467L4.393 6.273c-.22.22-.393.64-.393.947v5.447c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2zM12 10.667V10M4 9.987V9.32"
                />
                <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.665 3.333H6.332c-.553 0-1-.453-1-1s.447-1 1-1h3.333c.554 0 1 .454 1 1 0 .547-.446 1-1 1"
                />
            </svg>
        </span>
    )
}

export default ContainerIcon